import {API} from "../api/axios";
const END_POINT = "/exam-periods";
const END_POINT_PERIOD = "/periods";
const END_POINT_EXAM_PERIOD = "/exam-periods";
const END_POINT_ADD = "/student-list";
const END_POINT_ADD_FILTER = "/exam-periods/filter-add";
const END_POINT_STORE = "/student-mark";
const END_POINT_FILTER = "/exam-periods/filter";
class PeriodsService {
  getAll(params) {
    return API.get(END_POINT, params);
  }
  getFilter(params) {
    return API.get(END_POINT_FILTER, params);
  }
  ListStudentNotes(params) {
    return API.get(END_POINT_ADD, params);
  }
  AddPeriod(params) {
    return API.post(END_POINT_PERIOD, params);
  }
  AddExam(params) {
    return API.post(END_POINT, params);
  }
  ListingExamPeriod(params) {
    return API.get(END_POINT_EXAM_PERIOD, params);
  }
  ListScolarPeriodExamFilter(params) {
    return API.get(END_POINT_ADD_FILTER, params);
  }

  create(data) {
    return API.post(END_POINT_STORE, data);
  }
}

export default new PeriodsService();
